import { HubItemKind } from "client/Api/Hub/hubItemCategories";
import { useEffect } from "react";
import {
	HubEvent,
	subscribe,
	unsubscribe
} from "./events";
import { isNil } from "client/Misc/utils";

export function useHubItemsChangedListener(
	reloadData: () => void,
	kind?: HubItemKind
): void {
	useEffect(
		(): EffectWithDestructorResult => {
			const token: PubSubSubscriptionToken = subscribe(
				HubEvent.ItemsChanged,
				(_, data): void => {
					const {
						changedItemKinds
					} = data;

					if (isNil(kind) || changedItemKinds.has(kind)) {
						reloadData();
					}
				}
			);

			return (): void => unsubscribe(token);
		},
		[
			reloadData,
			kind
		]
	);
}